// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Categories_errorText__3E21N","pendingMessage":"Categories_pendingMessage__21Abq","container":"Categories_container__2oHay"};